import { Component, OnInit, Input, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { CedenteService } from './../../../../../../shared/services/cedente/cedente.service';
import { LocalStorageService } from './../../../../../../shared/services/local-storage/local-storage.service';

@Component({
  selector: 'app-card-cedente',
  templateUrl: './card-cedente.component.html',
  styleUrls: ['./card-cedente.component.scss']
})
export class CardCedenteComponent implements OnInit, AfterViewInit {
  @Input() public cedenteInput: any;
  @Output() private event: EventEmitter<any> = new EventEmitter();

  public cedente: any = {
    Agencia: '',
    Banco: '',
    Carteira: '',
    CedenteId: '',
    CodigoConvenio: '',
    CodigoTransmissao: '',
    ContaDigito: '',
    ContaId: '',
    ContaNumero: '',
    CpjCnpj: '',
    DataCadastro: '',
    DataModificacao: '',
    Descricao: '',
    NumeroCedente: '',
    Padrao: false,
    RazaoSocial: '',
  };

  public isEditing = false;
  public isLoading = false;
  public banco = '';
  public agencia = '';
  public numeroCedente = '';
  public conta = '';
  public digito = '';
  public codigoConvenio = '';
  public codigoTransmissao = '';
  public carteira = '';
  public errorMessage = '';

  public bancos: any[] = [
    { name: 'Bradesco', className: 'bradesco', number: '237' },
    { name: 'Santander', className: 'santander', number: '033' },
    { name: 'Banco do Brasil', className: 'banco-do-brasil', number: '001' }
  ];

  constructor(
    private elRef: ElementRef,
    private cedenteService: CedenteService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
      if (!this.cedenteInput) {
        return;
      }

      this.clickMenuListener();

      this.cedente = this.cedenteInput;

      if (this.cedente && this.cedente.CedenteId) {
        this.isEditing = false;
      } else {
        this.isEditing = true;
      }
  }

  ngAfterViewInit() {

  }

  submit(e) {
    let $submit;

    if (this.cedente && this.cedente.CedenteId) {
      this.cedente.Validacao = {};

      $submit = this.cedenteService.atualizar(this.cedente);
    } else {
      $submit = this.cedenteService.adicionar(this.cedente);
    }

    e.preventDefault();

    this.isLoading = true;
    this.cedente.ContaId = this.localStorage.get('login').PersonId;

    $submit
      .subscribe(() => {
        this.elRef.nativeElement.querySelector('.cedente').classList.remove('animate-card-up-cedente');
        this.elRef.nativeElement.querySelector('.cedente').classList.add('animate-card-up-cedente');

        this.isEditing = false;
        this.isLoading = false;
      }, (err) => {
        console.error(err);

        this.isLoading = false;
      });
  }

  toggleMenu(e) {
    const elements = this.elRef.nativeElement.querySelectorAll('.menu');
    const element = e.target.querySelector('.menu');

    if (!element) { return; }

    if (element.style.display === 'none') {
      elements.forEach((el) => {
        el.style.display = 'none';
      });

      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
  }

  edit() {
    this.isEditing = !this.isEditing;
    this.errorMessage = '';
  }

  remove(cedente) {
    if (cedente.Padrao) {
      this.errorMessage = 'Não é possível remover o cedente padrão';
      return;
    }

    this.elRef.nativeElement.querySelector('.cedente').classList.add('remove');

    this.cedenteService.remover(cedente.CedenteId).subscribe((data) => {
      const self = this;
      setTimeout(function() {
        self.event.emit({ name: 'delete' });
      }, 200);
    }, (err) => {
      console.error(err);
    });
  }

  cedentePadrao() {
    this.event.emit({ name: 'default', id: this.cedente.CedenteId });

    this.cedente.Padrao = true;
    this.cedente.Validacao = {};

    this.cedenteService.atualizar(this.cedente).subscribe((data) => {
      // todo
    }, (err) => {
      console.error(err);
    });
  }

  clickMenuListener() {
    const self = this;
    document.querySelector('body').addEventListener('click', function(e: any) {
      if (e.target.className !== 'menu' && e.target.className !== 'menu-button') {
        const elements = self.elRef.nativeElement.querySelectorAll('.menu');
        elements.forEach((el) => {
          if (el.style.display === 'block') {
            el.style.display = 'none';
          }
        });
      }
    });
  }
}
